module.exports = __webpack_public_path__ + "images/royalty-e578a5defdc4c372534ef249aec5b143.png";